import { render, staticRenderFns } from "./LicenseKindTable.vue?vue&type=template&id=17dabc88&scoped=true"
import script from "./LicenseKindTable.vue?vue&type=script&lang=js"
export * from "./LicenseKindTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17dabc88",
  null
  
)

export default component.exports